export const ACCESS_KEY_VOYAGE_READ = 'acl.voyage.READ'
export const ACCESS_KEY_VOYAGE_WRITE = 'acl.voyage.WRITE'
export const ACCESS_KEY_VOYAGE_ALL = 'acl.voyage.ALL'

export const ACCESS_KEYS_VOYAGE_WRITE:string[] = [ACCESS_KEY_VOYAGE_WRITE,ACCESS_KEY_VOYAGE_ALL]
// View-only access to voyages: exactly what the backend asks of read-only screens (the stadium,
// the voyage planning grid).
// WRITE and ALL are listed because they imply READ rather than granting it as a separate key.
export const ACCESS_KEYS_VOYAGE_VIEW:string[] = [ACCESS_KEY_VOYAGE_READ,ACCESS_KEY_VOYAGE_WRITE,ACCESS_KEY_VOYAGE_ALL]